import React, { useState } from 'react';
import { api } from '../api.js';

export function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(null); setBusy(true);
    try {
      const r = await api.login(username, password);
      onLogin(r.user);
    } catch (err) {
      setError(err.status === 401 ? 'Invalid username or password.' : (err.message || 'Sign-in failed.'));
    } finally { setBusy(false); }
  };

  return (
    <div className="login-shell">
      <form className="login-card" onSubmit={submit}>
        <img src="/yuno-mark.svg" alt="" style={{ width: 48, height: 48, borderRadius: 12, marginBottom: 16 }} />
        <h1>Hooks</h1>
        <p>Sign in to inspect webhooks delivered to your endpoints.</p>

        {error && (
          <div style={{
            background: 'var(--danger-50)', color: '#8a1820',
            padding: '8px 12px', borderRadius: 8, fontSize: 13,
            marginBottom: 16, border: '1px solid var(--danger-100)',
            textAlign: 'left',
          }}>{error}</div>
        )}

        <label className="login-field">
          <span>Username</span>
          <input
            autoFocus autoComplete="username"
            value={username} onChange={(e) => setUsername(e.target.value)}
            disabled={busy}
          />
        </label>

        <label className="login-field">
          <span>Password</span>
          <input
            type="password" autoComplete="current-password"
            value={password} onChange={(e) => setPassword(e.target.value)}
            disabled={busy}
          />
        </label>

        <button type="submit" className="btn btn-primary" disabled={busy} style={{ width: '100%', marginTop: 8, padding: '10px 12px', fontSize: 14, justifyContent: 'center' }}>
          {busy ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </div>
  );
}
